import { AiToolOffice } from '../../../common/ai-details/ai-tool-office';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { LoaderService } from '../../loader/loader.service';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import * as jwt_decode from 'jwt-decode';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
export enum AIStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  FOLLOW_UP = 'FOLLOW_UP'
}

export interface QuestionScore {
  questionTitle: string;
  weight: number;
  status: AIStatus;
  value: number;
}

@Component({
  selector: 'app-qualifyingScoringbreakdown',
  templateUrl: './qualifyingScoringbreakdown.component.html',
  styleUrls: ['./qualifyingScoringbreakdown.component.scss']
})
export class QualifyingScoringbreakdownComponent implements OnInit, OnChanges {

  @Input() transactionID: number = 0;
  @Input() documentsId: number = 0;
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  ThresholdList:any=[]=[];
  
  @Output() sendDeletedQuery = new EventEmitter();
  @Output() sendsaveUpdateQuery = new EventEmitter();
  @Output() sendPageNumber = new EventEmitter();

  responseHolder: any = [] = [];
  organizationId: string;
  databaseId: string;  
  
  menuModulesList: any;
  CoreShowName: any; 
  rules:any=[]=[];
  rulesCount:any=[]=[];

  AIStatus = AIStatus;

  recommendation: 'Pass' | 'Fail' = 'Fail';
  totalScore = 0;
  maxScore = 100;
  mandatoryRuleTriggered = true;

  // questions: QuestionScore[] = [
  //   // {
  //   //   questionTitle: 'Resident must not have severe alcohol (ETOH) dependence with withdrawal symptoms.',
  //   //   weight: 10,
  //   //   status: AIStatus.FAIL,
  //   //   value: 0
  //   // },
  //   {
  //     questionTitle: 'Resident must not be on a feeding tube.',
  //     weight: 10,
  //     status: AIStatus.FAIL,
  //     value: 0
  //   },
  //   {
  //     questionTitle: 'Resident must not be on Seroquel (Quetiapine).',
  //     weight: 7,
  //     status: AIStatus.FOLLOW_UP,
  //     value: 0.5
  //   },
  //   // {
  //   //   questionTitle: 'Resident must not be bariatric (over 300 lbs).',
  //   //   weight: 9,
  //   //   status: AIStatus.PASS,
  //   //   value: 1
  //   // },
  //   // {
  //   //   questionTitle: 'Resident must not have a traumatic brain injury (TBI) with associated behaviors.',
  //   //   weight: 8,
  //   //   status: AIStatus.PASS,
  //   //   value: 1
  //   // },
  //   // {
  //   //   questionTitle: 'Resident requires assistance with activities of daily living (ADLs).',
  //   //   weight: 6,
  //   //   status: AIStatus.PASS,
  //   //   value: 1
  //   // },
  //   // {
  //   //   questionTitle: 'Resident has stable medical conditions.',
  //   //   weight: 7,
  //   //   status: AIStatus.PASS,
  //   //   value: 1
  //   // }
  // ];

 

  totalWeight:number=0;
  totalcontribution:number=0;
  qualifyResult:number=0;
  Recommendation:string="";
  thresholdValue:number=0;
  overAllContribution:number=0;
  
  constructor(private _dataSharingService: DataSharingService, private formsService: FormsService, private loaderService: LoaderService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private toastr: ToastrService,
    private dialog: MatDialog, private formBuilder: FormBuilder) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    let SelectedCore = this.menuModulesList.filter((x) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = AiToolOffice.resolve(oe.officeID);   // [per-office] the office the open AI tool works for
    });
  }

  ngOnInit(): void {
   
  }

  ngOnChanges(changes: SimpleChanges) {
   this.getThresholdRules();
  }

  getThresholdRules() {
   var ReqModel = {
      coreID: this.transactionID,
      documentID:this.documentsId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.getReferralQuestionAnswers(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ThresholdList=this.responseHolder.data.questions;
          this.qualifyResult = this.responseHolder.data.qualifyResult;
          this.overAllContribution = this.responseHolder.data.overAllContribution;
          this.thresholdValue = this.responseHolder.data.thresholdValue;

          if(this.qualifyResult==0){
           this.Recommendation="Fail";
          }
          if(this.qualifyResult==1){
            this.Recommendation="Pass";
          }
           if(this.qualifyResult==2){
            this.Recommendation="Follow Up";
          }
           if(this.ThresholdList.length>0){
            
             this.ThresholdList.forEach(e => {
             
              //=== Fail ===//
              if(e.finalResult==0){
                e.value=0.0;
              }
              //=== Pass ===//
              if(e.finalResult==1){
                e.value=1.0;
              }
               //=== Follow Up ===//
               if(e.finalResult==2){
                e.value=0.5;
              }

               // === Contribution Calculation ===//
              //  const weight = e?.weight ?? 0;
              //  const value = e?.value ?? 0;
              //  e.contribution = +(weight * value).toFixed(1);
             });

             //this.totalWeight = (this.ThresholdList.length)*10;//this.ThresholdList.reduce((sum, item) => sum + item.weight,0);
             //this.totalcontribution = this.ThresholdList.reduce((sum, item) => sum + item.contribution,0);
           }
               
        } else {
         this.ThresholdList=[];
         this.loaderService.hide();
        }
      } else {
        this.ThresholdList=[];
        this.loaderService.hide();
      }
    });
  }
 
    // getContribution(q: any): number {
    //   const weight = q?.weight ?? 0;
    //   const value = q?.value ?? 0;
    //   return +(weight * value).toFixed(1);
    // }
  
}
